import { HealthInsuranceCardData } from './HealthInsuranceCardMapper.types'

class HealthInsuranceCardMapper {
  toDomain(persistenceData: HealthInsuranceCardData) {
    return {
      healthInsuranceId: persistenceData?.id,
      healthInsuranceNumber: persistenceData?.numeroCarteira,
      multipleHealthInsuranceCards: persistenceData?.multipleCards,
    }
  }
}

export default new HealthInsuranceCardMapper()
